import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { I18NextModule } from 'angular-i18next';
import { NavigationService } from './services/navigation.service';
import { LocalizerService } from './services/localizer.service';
import { I18nRoutePipe } from './pipes/i18n-route.pipe';
import { ScreenService } from './services/screen.service';
import { PasswordPipe } from './pipes/password.pipe';
import { AccessLevelIconPipe } from './pipes/access-level-icon.pipe';
import { AccessLevelTitlePipe } from './pipes/access-level-title.pipe';
import { ProductLineNamePipe, ProductTypeNamePipe } from './pipes/product-line.pipe';
import { ThingNameToSerialNumberPipe } from './pipes/thingname-to-serial-number.pipe';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AccountThumbnailComponent } from './components/account-thumbnail/account-thumbnail.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { WidgetCardComponent } from './components/widget-card/widget-card.component';
import {
    DxButtonModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxLoadPanelModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTooltipModule
} from 'devextreme-angular';
import { FullAddressPipe } from './pipes/full-address.pipe';
import { LabelComponent } from './components/label/label.component';
import { NoDomainEmailPipe } from './pipes/no-domain-email.pipe';
import { ImageUploadService } from './services/image-upload.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { LottieComponent } from 'ngx-lottie';
import { FarfisaDeviceToOutputsStringPipe, FarfisaDevicesToStringPipe, UnitDevicesToStringPipe } from './pipes/devices.pipe';
import { NetworkService } from './services/network.service';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ShimmerOverlayComponent } from './components/shimmer-overlay/shimmer-overlay.component';
import { CognitoAuthenticationManager } from './services/cognito-authentication-manager';
import { LabelBackgroundPipe } from './pipes/label-background.pipe';
import { RedirectingPageComponent } from './components/redirecting-page/redirecting-page.component';
import { IotService } from "./services/iot.service";
import { CallEventsCardComponent } from './components/call-event/call-events-card/call-events-card.component';
import {CallEventFiltersComponent} from "./components/call-event/call-event-filters/call-event-filters.component";
import { CallEventComponent } from './components/call-event/call-event/call-event.component';
import { IncomingCallCardComponent } from './components/incoming-call-card/incoming-call-card.component';
import { PermissionsBannerComponent } from './components/permissions-banner/permissions-banner.component';
import {CallSessionManager} from "./services/call-session-manager.service";
import { DeviceInStatusPipe } from './pipes/device-in-status.pipe';
import { DeviceSupportCallv2Pipe } from './pipes/device-support-callv2.pipe';
import { CallStateDebugCardComponent } from './components/call-state-debug-card/call-state-debug-card.component';
import { ConnectivityOverlayComponent } from './components/connectivity-overlay/connectivity-overlay.component';
import { EntityCarouselComponent } from './components/entity-carousel/entity-carousel.component';
import { ClockSyncService } from './services/clock-sync.service';
import { RingtoneService } from './services/ringtone.service';



@NgModule({
    declarations: [
        I18nRoutePipe,
        PasswordPipe,
        AccessLevelIconPipe,
        AccessLevelTitlePipe,
        ProductLineNamePipe,
        ProductTypeNamePipe,
        ThingNameToSerialNumberPipe,
        FarfisaDeviceToOutputsStringPipe,
        FarfisaDevicesToStringPipe,
        UnitDevicesToStringPipe,
        FullAddressPipe,
        NoDomainEmailPipe,
        LabelBackgroundPipe,
        AccountThumbnailComponent,
        BreadcrumbComponent,
        WidgetCardComponent,
        LabelComponent,
        SpinnerComponent,
        PageHeaderComponent,
        ShimmerOverlayComponent,
        RedirectingPageComponent,
        CallEventFiltersComponent,
        CallEventsCardComponent,
        CallEventComponent,
        IncomingCallCardComponent,
        PermissionsBannerComponent,
        DeviceInStatusPipe,
        DeviceSupportCallv2Pipe,
        CallStateDebugCardComponent,
        ConnectivityOverlayComponent,
        EntityCarouselComponent
    ],
    exports: [
        I18NextModule,
        I18nRoutePipe,
        PasswordPipe,
        AccessLevelIconPipe,
        AccessLevelTitlePipe,
        ProductLineNamePipe,
        ProductTypeNamePipe,
        ThingNameToSerialNumberPipe,
        FarfisaDeviceToOutputsStringPipe,
        FarfisaDevicesToStringPipe,
        UnitDevicesToStringPipe,
        FullAddressPipe,
        NoDomainEmailPipe,
        LabelBackgroundPipe,
        DeviceInStatusPipe,
        DeviceSupportCallv2Pipe,
        AccountThumbnailComponent,
        BreadcrumbComponent,
        WidgetCardComponent,
        LabelComponent,
        SpinnerComponent,
        PageHeaderComponent,
        ShimmerOverlayComponent,
        CallEventFiltersComponent,
        CallEventsCardComponent,
        IncomingCallCardComponent,
        PermissionsBannerComponent,
        CallStateDebugCardComponent,
        ConnectivityOverlayComponent,
        EntityCarouselComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule,
        AngularSvgIconModule,
        DxButtonModule,
        LottieComponent,
        FormsModule,
        I18NextModule.forRoot(),
        DxSelectBoxModule,
        DxDateBoxModule,
        ReactiveFormsModule,
        DxLoadPanelModule,
        DxPopupModule,
        DxScrollViewModule,
        DxTooltipModule
    ],
    providers: [
        IotService,
        CallSessionManager,
        ScreenService,
        NavigationService,
        LocalizerService,
        ImageUploadService,
        NetworkService,
        CognitoAuthenticationManager,
        ClockSyncService,
        RingtoneService,
        AccessLevelTitlePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class SharedModule { }
